import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
export const AnniversaryPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Check if popup has been shown in this session
    const hasShown = sessionStorage.getItem('igs-anniversary-popup-shown');
    if (!hasShown) {
      // Small delay to allow page to load before showing popup
      const timer = setTimeout(() => {
        setIsVisible(true);
        document.body.style.overflow = 'hidden'; // Prevent scrolling
      }, 500);
      return () => clearTimeout(timer);
    }
  }, []);
  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem('igs-anniversary-popup-shown', 'true');
    document.body.style.overflow = 'unset'; // Restore scrolling
  };
  // Cleanup on unmount just in case
  useEffect(() => {
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);
  return <AnimatePresence data-id="element-231">
      {isVisible && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6 md:p-12" data-id="element-232">
          {/* Dark Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={handleClose} data-id="element-233" />

          {/* Popup Content */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.8,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="relative w-full max-w-3xl max-h-[90vh] flex flex-col items-center justify-center z-10" data-id="element-234">
            {/* Close Button */}
            <button onClick={handleClose} className="absolute -top-4 -right-4 md:-top-6 md:-right-6 bg-white text-blue-900 p-2 rounded-full shadow-xl hover:bg-yellow-400 hover:text-blue-950 transition-colors duration-200 z-20 focus:outline-none focus:ring-2 focus:ring-yellow-500" aria-label="Close popup" data-id="element-235">
              <XIcon className="w-6 h-6" data-id="element-236" />
            </button>

            {/* Image Container */}
            <div className="relative w-full h-full overflow-hidden rounded-xl shadow-2xl bg-blue-950/50" data-id="element-237">
              <img src="https://cdn.magicpatterns.com/uploads/k2BvjZy7n4KdfdkpLXvwi5/WhatsApp_Image_2026-03-17_at_13.15.58.jpg" alt="IGS @ 70 — Celebrating 70 Years of Impactful & Enduring Legacy in Education. 23rd–29th March, 2026. Still Soaring at Seventy." className="w-full h-auto max-h-[85vh] object-contain rounded-xl" data-id="element-238" />
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
};